import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'navaar-one-star-icon',
  template: `<svg xmlns="http://www.w3.org/2000/svg"  [ngStyle]="style"  width="10.91" height="10.4"  id="_25182" data-name="25182" xmlns="http://www.w3.org/2000/svg" width="10.91" height="10.405" viewBox="0 0 10.91 10.405">
  <path id="Path_2930" data-name="Path 2930" d="M10.91,15.022q0-.243-.367-.3l-3.291-.479L5.776,11.259q-.124-.269-.321-.269t-.321.269L3.658,14.242.367,14.72Q0,14.78,0,15.022a.5.5,0,0,0,.164.315L2.55,17.658l-.564,3.278a1.065,1.065,0,0,0-.013.131.386.386,0,0,0,.069.233.238.238,0,0,0,.206.1.556.556,0,0,0,.262-.079l2.944-1.547L8.4,21.316a.531.531,0,0,0,.262.079.231.231,0,0,0,.2-.1.387.387,0,0,0,.069-.233.99.99,0,0,0-.007-.131l-.564-3.278,2.38-2.321A.474.474,0,0,0,10.91,15.022Z" transform="translate(0 -10.99)" fill="#ffad00"/>
</svg>`
})

export class OneStarIconComponent implements OnInit {
  @Input() public style: object = {};
  constructor() { }

  ngOnInit(): void {
  }

}
